import { render } from "./Qna_1.vue?vue&type=template&id=8234e838&scoped=true"
import script from "./Qna_1.vue?vue&type=script&lang=js"
export * from "./Qna_1.vue?vue&type=script&lang=js"

import "./Qna_1.vue?vue&type=style&index=0&id=8234e838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8234e838"]])

export default __exports__